function timeConvert(num) {
    if (num === 0) return '00:00'
    if (num) return new Date(num).toISOString().slice(14, -5);
}

export default timeConvert